import { Map } from "immutable"
import * as React from "react"
import { ApiResult, isLoaded } from "../../../Shared/api/apiTypes"
import { Region } from "../../custom_api/api"

export type Period = "vandaag" | "morgen" | "komende zeven dagen" | "komende dertig dagen" | "elk moment"
export type PeriodSlug = "vandaag" | "morgen" | "komende-zeven-dagen" | "komende-dertig-dagen" | "any"

interface RegionAndDateFilterProps {
  readonly enabled: boolean
  readonly regions: ApiResult<Map<string, Region>>
  readonly selectedPeriod: PeriodSlug
  readonly selectedRegion: string
  readonly selectPeriod: (e: React.ChangeEvent<HTMLSelectElement>) => void
  readonly selectRegion: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

interface RegionAndDateFilterState { }

export const periods: Map<PeriodSlug, Period> = Map<PeriodSlug, Period>([
  ["vandaag", "vandaag"],
  ["morgen", "morgen"],
  ["komende-zeven-dagen", "komende zeven dagen"],
  ["komende-dertig-dagen", "komende dertig dagen"],
  ["any", "elk moment"],
])

const regionAndDateFilterStateZero: RegionAndDateFilterState = {}

// The defaultValue attribute doesn't seem to be compatible with controlled components

export class RegionAndDateFilter extends React.Component<RegionAndDateFilterProps, RegionAndDateFilterState> {
  constructor(props: RegionAndDateFilterProps) {
    super(props)

    this.state = regionAndDateFilterStateZero
  }

  render() {
    const p = this.props

    const periodFilter: JSX.Element = (
      <div className="region-date__select form__select">
        <select onChange={p.selectPeriod} disabled={!p.enabled} value={p.selectedPeriod} id="rd-date">
          {periods.map((title, slug) => <option key={title} value={slug}>{title}</option>).toArray()}
        </select>
      </div>
    )

    const regionFilter: JSX.Element = (
      <div className="region-date__select form__select">
        <select onChange={p.selectRegion} value={p.selectedRegion} disabled={!p.enabled} id="rd-region">
          <option key="overal" value="">overal</option>
          {isLoaded(p.regions) && p.regions
            .sort()
            .map((x, k) => <option key={x.slug} value={x.slug}>{k}</option>)
            .toArray()}
        </select>
      </div>
    )

    return (
      <fieldset className="region-date">
        <legend className="sr-text">Filter activiteiten op datum en plaats</legend>
        <div className="region-date__inner">
          <div className="region-date__filter">
            <label className="region-date__text" htmlFor="rd-date">Wanneer?</label>
            {periodFilter}
          </div>
          <div className="region-date__filter">
            <label className="region-date__text" htmlFor="rd-region">Waar?</label>
            {regionFilter}
          </div>
        </div>
      </fieldset>
    )
  }
}
